// src/store/services/coach.js
import feathersClient, {
  makeServicePlugin,
  BaseModel
} from "../../feathers-client";

class TraineeCompetencies extends BaseModel {
  constructor (data, options) {
    super(data, options);
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = "TraineeCompetencies";
  // Define default properties here
  static instanceDefaults () {
    return {
      id: null,
      usersId: null,
      competencyId: null,
      initialLevel: null,
      createdAt:null,
      motivationSurveyDate:null,
      trainingDuration: null,
      progressStatus: null
    };
  }
}
const servicePath = "trainee-competencies";
const servicePlugin = makeServicePlugin({
  Model: TraineeCompetencies,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
});

export default servicePlugin;
